<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <div fxFlex="50">
    <div><span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span></div>
  </div>
  <div fxFlex="50" class="text-right">

  </div>
</div>


<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
  <div fxFlex="50">


    <div>
      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>Last load files</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <table class="list-table" style="word-wrap:break-word; table-layout: fixed; margin-bottom: 10px;">
            <tr>
              <th class="" style="text-align: left; width: 150px;"><label>Date</label></th>
              <th style="text-align: left;"><label></label></th>
              <th style="width: 70px"></th>
            </tr>
            <tr *ngFor="let f of this.lastFiles">
              <td class=""><label>{{ f.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
              <td><label>{{f.originalFileName}}</label></td>
              <td style="text-align: right">
                <button color="primary" mat-raised-button (click)="downloadFile(f.id)" aria-label="download">
                  <mat-icon>arrow_circle_down</mat-icon>
                </button>
              </td>


            </tr>
          </table>


        </mat-card-content>
      </mat-card>
    </div>
  </div>
